import { SpaceVoData } from "../..";
var SpacesConverter = /** @class */ (function () {
    function SpacesConverter() {
    }
    SpacesConverter.convertSpaceToVo = function (spacesApiData) {
        var spacesVoData = [];
        for (var _i = 0, spacesApiData_1 = spacesApiData; _i < spacesApiData_1.length; _i++) {
            var space = spacesApiData_1[_i];
            var spaceVoData = new SpaceVoData(space.id);
            spaceVoData.name = space.name;
            spaceVoData.type = space.type;
            spacesVoData.push(spaceVoData);
        }
        return spacesVoData;
    };
    return SpacesConverter;
}());
export { SpacesConverter };
//# sourceMappingURL=spaces-converter.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/utils/converter/spaces-converter.js
// module id = 972
// module chunks = 14